import React, { useEffect, useState } from 'react';
import { fetchSurveyConsentStatus } from '../utils/availabilityInquiry';
import './AvailabilityInquiryModal.css';

const AvailabilityInquiryModal = ({
  open,
  product,
  defaultEmail = '',
  onClose,
  onContinue,
  onSkip,
}) => {
  const [email, setEmail] = useState(String(defaultEmail || '').trim());
  const [surveyConsent, setSurveyConsent] = useState(false);
  const [consentOnFile, setConsentOnFile] = useState(false);

  useEffect(() => {
    if (!open) return;
    setEmail(String(defaultEmail || '').trim());
    setSurveyConsent(false);
    setConsentOnFile(false);
  }, [open, defaultEmail, product]);

  useEffect(() => {
    if (!open) return undefined;
    const normalized = String(email || '').trim().toLowerCase();
    if (!normalized) {
      setConsentOnFile(false);
      return undefined;
    }

    let cancelled = false;
    fetchSurveyConsentStatus(normalized).then((status) => {
      if (!cancelled) {
        setConsentOnFile(Boolean(status?.hasSurveyConsent));
      }
    });

    return () => {
      cancelled = true;
    };
  }, [open, email]);

  if (!open || !product) return null;

  const productName = String(product?.name || product?.title || 'this product').trim();
  const effectiveConsent = consentOnFile || surveyConsent;

  const handleSubmit = (e) => {
    e.preventDefault();
    onContinue({
      email: email.trim(),
      surveyConsent: effectiveConsent && Boolean(email.trim()),
    });
  };

  return (
    <div className="availability-inquiry-overlay" onClick={onClose} role="presentation">
      <div
        className="availability-inquiry-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="availability-inquiry-title"
        aria-modal="true"
      >
        <button type="button" className="availability-inquiry-close" onClick={onClose} aria-label="Close">
          ×
        </button>
        <h2 id="availability-inquiry-title">Before you chat with the store</h2>
        <p className="availability-inquiry-lead">
          You&apos;re about to check availability for <strong>{productName}</strong> on WhatsApp.
          Optionally leave your email so we can follow up and invite you to share feedback after your purchase.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="availability-inquiry-field">
            <label htmlFor="availability-inquiry-email">Email (optional)</label>
            <input
              id="availability-inquiry-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              autoComplete="email"
            />
          </div>
          {email.trim() && !consentOnFile && (
            <label className="availability-inquiry-consent">
              <input
                type="checkbox"
                checked={surveyConsent}
                onChange={(e) => setSurveyConsent(e.target.checked)}
              />
              <span>
                I agree to receive a Google Customer Reviews survey about my experience with Raheasy.
              </span>
            </label>
          )}
          <div className="availability-inquiry-actions">
            <button type="submit" className="availability-inquiry-btn primary">
              Continue
            </button>
            <button type="button" className="availability-inquiry-btn secondary" onClick={onSkip}>
              Skip and open WhatsApp
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AvailabilityInquiryModal;
